import { US, US_AND_CANADA, VALID_REGIONS } from '../constants';
 
import { ContentValueChartInfo } from 'types';
import PlatformLinkBuilder from '../../../../utils/integration/PlatformLinkBuilder';

interface QueryParams {
  region?: string;
  month_count?: number;
  hide_filters?: boolean;
  publications?: number;
  content_value?: string;
}

interface MonthlyData extends ContentValueChartInfo {
  lineDataLabel: string;
}

const getDate = () => {
  const date = new Date();
  const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  const dateTimeFormat = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: 'short',
  });
  const [{ value: month }, , { value: year }] = dateTimeFormat.formatToParts(lastDay);

  return `${month} ${year}`;
};

const removeCentsAddCommas = (pubNum: number) => {
  return Number(pubNum).toLocaleString('en', {
    minimumFractionDigits: 0,
  });
};

const firstDate = (firstRequested: string) => {
  return firstRequested || 'Jul 2019';
};

const lastDate = (lastRequested: string) => {
  return lastRequested || getDate();
};

const digitFormatter = (num: number) => {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return num.toFixed(0);
};

const createChartData = (elem: ContentValueChartInfo, region: string) => {
  const regionLowerCase = () => {
    if (region === US) {
      return region.toLowerCase();
    }
    if (region === US_AND_CANADA) {
      return 'all';
    }
    return region.charAt(0).toLowerCase() + region.slice(1);
  };

  const { month, barData } = elem;
  // @ts-ignore
  const lineData = elem.lineData[regionLowerCase()];

  return {
    month,
    lineData,
    lineDataLabel: `$${digitFormatter(lineData)}`,
    barData,
  };
};

function percIncrease(pub: number, benchmark: number) {
  if (!pub && !benchmark) {
    return 0;
  }

  const percent = (100 * (pub - benchmark)) / benchmark;
  return Math.floor(percent);
}

const generateLink = (queryParams: QueryParams, route: string) => {
  // @ts-ignore
  const searchParams = new URLSearchParams(queryParams);
  return PlatformLinkBuilder.build(`${route}${searchParams.toString()}`);
};

const validateStoredRegion = (storedRegion: string) => {
  if (!VALID_REGIONS.includes(storedRegion)) {
    localStorage.setItem('contentValueRegion', US_AND_CANADA);
  }
};

const addTooltipToMonthlyData = (
  monthlyData: MonthlyData[],
  toolTipData: { [x: string]: string }
) => monthlyData.map((item, i: string | number) => Object.assign({}, item, toolTipData[i]));

export {
  removeCentsAddCommas,
  firstDate,
  lastDate,
  createChartData,
  percIncrease,
  generateLink,
  validateStoredRegion,
  addTooltipToMonthlyData,
  digitFormatter,
};
